module.exports = __webpack_public_path__ + "static/media/turntables.33fb1ded.mov";